import { useState } from 'react'
import { useSnackbar } from 'notistack';
import { Autocomplete, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { reserveRateChangeStatus } from '../apiService';
import { globalPostService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { useDispatch } from 'react-redux';
import { fetchLeaseBasicDetails } from '../../../shared_elements/actionCreators';

const ReserveStatusChange = ({ changeStatusLeases, onToggleModal, params, getResponseBack, getReserveRateList,queryConfig }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch()
  const [statusData, setStatusData] = useState({status :changeStatusLeases?.data?.status === true ? {id:true,label :"Active"}:{id:false,label :"Inactive"}});
  const [error, setError] = useState({});
  const [isLoading, setLoading] = useState(false);
  const statusLabel = [{ id: true, label: "Active" }, { id: false, label: "Inactive" },]
  const onFieldChange = (key, value) => {
    setStatusData({ ...statusData, [key]: value });
    setError({ ...error, [key]: "" });
  }
  const handleLeaseStatusChange = () => {
    if (statusData?.status !== null ) {
     
      if (changeStatusLeases?.data?.id) {
        setLoading(true);
        const payload = { status: statusData?.status?.id,ids: [changeStatusLeases?.data?.id] };
        globalPostService(reserveRateChangeStatus(params?.leaseSlug), payload)
          .then((response) => {
            if (checkApiStatus(response)) {
              enqueueSnackbar(response?.data?.message, {
                variant: "success",
                anchorOrigin: { horizontal: "right", vertical: "top" },
                hideIconVariant:true,
              });
              onToggleModal();
              getResponseBack();
              trackActivity('Item Edited', { page_title: `Change Reserve Rate Status`, success_msg: response?.data?.message, item_id: changeStatusLeases?.data?.id, payload: payload, response: response?.data })
              getReserveRateList(queryConfig,"isFetch")
              dispatch(fetchLeaseBasicDetails({ slug: params?.leaseSlug, setLoading }));
            } else {
              //toast message
              enqueueSnackbar(response.data.message, {
                variant: "error",
                anchorOrigin: { horizontal: "right", vertical: "top" },
                hideIconVariant:true,
              });
            }
            trackActivity('Item Edited', { page_title: `Change Reserve Rate Status`, error_msg: response?.data?.message, item_id: changeStatusLeases?.data?.id, payload: payload, response: response?.data })
            setLoading(false);
          });
      }
    } else {
      setError({status :"Please select Reserve Rate Status"});
      trackActivity(`Item Edited`, { page_title: `Change Reserve Rate Status`, error_msg: {status :"Please select Reserve Rate Status"}, })
    }
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Reserve Rate Status`, page_type: page_type, })
  }
  return (
    <Dialog aria-labelledby="customized-dialog-title"
      className='add-lease-dialog'
      open={changeStatusLeases?.modal}
      maxWidth="sm"
      
    >
      <DialogTitle sx={{ m: 0, p: 2, pl:3 }} className='dialog-header' id="customized-dialog-title">
        Reserve Rate Status
      </DialogTitle>
      <DialogContent sx={{width:450,height:80}} dividers>
        <Grid container spacing={2}>
          <Grid size={{ md: 12, xs: 12, }} mt={2}>
            <Autocomplete
              disablePortal
              disableClearable
              sx={{width:450}}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              options={statusLabel}
              getOptionLabel={(option) => option.label || ""}
              value={statusData?.status}
              onChange={(e,value) => {onFieldChange("status", value)}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  label="Reserve Rate Status"
                  margin="normal"
                  size="small"
                  error={Boolean(error.status)}
                  helperText={error.status}
                  slotProps={{ inputLabel: { shrink: true } }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{
        marginRight:"15px",
        padding: 1,
        justifyContent: 'flex-end',
      }}>
        <Button className='cancel-btn' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} size='small' variant='outlined'>Cancel</Button>
        <Button className='btn-primary' size='small' variant='contained' onClick={() => { handleItemClicked('Save Button'); handleLeaseStatusChange() }} >{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ReserveStatusChange